import TileLayer from 'ol/layer/WebGLTile';
import XYZSource from 'ol/source/XYZ';

export default class Chb2BerthMap extends TileLayer {
    static get layerName() {
        return 'chb2-berth-map';
    }

    constructor(opt_options) {
        super(Object.assign({
            name: Chb2BerthMap.layerName,
            source: new XYZSource({
                crossOrigin: 'anonymous',
                url: '/fairway/api/tileBerth/{z}/{x}/{y}',
            })
        }, opt_options));
    }
}
